import t from"react";import{Container as e}from"./styles.js";const r=({children:r,vertical:o=0,horizontal:a=0,top:i=o,right:l=a,bottom:m=o,left:p=a,...c})=>t.createElement(e,{$padding:[i,l,m,p],...c},r);r.displayName="Spacer";export{r as Spacer};
//# sourceMappingURL=Spacer.js.map
